export const getAutocompleteToken = (name) => {
  switch (name) {
    case "phoneNumber":
    case "preferredPhoneNumber":
      return "tel";
    case "email":
      return "email";
    case "dateOfBirth":
      return "bday";
    case "gender":
      return "sex";
    case "language":
      return "language";
    case "address":
      return "street-address";
    case "faxNumber":
      return "fax";

    case "labValue":
    case "labName":
    case "screeningName":
    case "screeningValue":
    case "timezone":
    case "allergies":
    case "age":
    case "preferredContactMethod":
    case "date":
    case "search":
      return "off";
    default:
      return "off";
  }
};
